import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { WEB_COMPONENT_GZ_INFO_BOX } from '../../../../webcomponents.constants';

export const templateCompanyLicensingTab = document.createElement('template');

templateCompanyLicensingTab.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='main-container'>

      <${WEB_COMPONENT_GZ_INFO_BOX} class='hidden'></${WEB_COMPONENT_GZ_INFO_BOX}>

      <div class='cards-container'>
        <div class='licensing-card'>
          <gz-title fontSize='11' fontWeight='600' class='card-title' id='license-card-title'></gz-title>

          <div class="w-full">
            <gz-copy-to-clipboard id='copyToClipboardCompanyId'>
              <gz-form-field id='company-id' class='label-mw-250 w-full' label='' readonly>
                <gz-input gz-form-input placeholder=''></gz-input>
              </gz-form-field>
            </gz-copy-to-clipboard>
          </div>
          <div class="w-full">
            <gz-copy-to-clipboard id='copyToClipboardCompanyHash'>
              <gz-form-field id='company-hash' class='label-mw-250 w-full' label='' readonly>
                <gz-input gz-form-input placeholder=''></gz-input>
              </gz-form-field>
            </gz-copy-to-clipboard>
          </div>
          <div class="licensing-payment-plan">
              <gz-form-field id='payment-plan' class='label-mw-250' label='' readonly>
                <gz-input gz-form-input placeholder=''></gz-input>
              </gz-form-field>
          </div>
          <div class='hidden' id='mdr-container'>
            <gz-labeled-content id='mdr-subscription-type' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
            <gz-labeled-content id='mdr-start-end-date' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
            <gz-labeled-content id='mdr-status' labelfontsize='14' hasColon='true' hasFormLabelWidth='true'></gz-labeled-content>
          </div>
          <div class='hidden' id='aws-subscription-container'>
            <span class='label' id='aws-subscription-label'></span>
            <span class='value value-marketplace-link'>
              <gz-link type="underline" href='' id='aws-marketplace-link' class='hidden'><span>
                <img id='aws-marketplace-link-image' alt='' src='app/webcomponents/assets/images/aws/editorial_logo_aws-marketplace.png' />
              </span></gz-link>
            </span>
            <span class='value value-pan-link'>
              <img class='hidden' id='aws-pan-link-image' alt='' src='app/webcomponents/assets/images/aws/editorial_logo_aws-pan.png' />
            </span>
          </div>

          <div class="licensing-card-buttons-container">
            <div class="licensing-card-buttons">
              <gz-button class='licensing-card-button hidden' id='edit-licensing-options' lowercase='true' type='outline' buttonHeight='small' buttonFontSize='small'></gz-button>
              <gz-button class='licensing-card-button hidden' id='change-to-pre-paid-license' lowercase='true' type='outline' buttonHeight='small' buttonFontSize='small'></gz-button>
              <gz-button class='licensing-card-button' id='show-monthly-usage-report-menu-button' lowercase='true' type='outline' buttonHeight='small' buttonFontSize='small'></gz-button>
            </div>
            <gz-iz-integration-status class="licensing-card-iz"></gz-iz-integration-status>
          </div>
        </div>

        <div class='hidden licensing-card' id='parent-company-details-card'>
          <gz-title fontSize='11' fontWeight='500' class='card-title' id='parent-company-card-title'></gz-title>

          <gz-form-field id='partner-name' class='label-mw-250' label='' readonly >
            <gz-input gz-form-input placeholder=''></gz-input>
          </gz-form-field>

          <gz-form-field id='partner-id' class='label-mw-250' label='' readonly>
            <gz-input gz-form-input placeholder=''></gz-input>
          </gz-form-field>

          <gz-form-field id='partner-address' class='label-mw-250' label='' readonly>
            <gz-input gz-form-input placeholder=''></gz-input>
          </gz-form-field>

          <gz-form-field id='partner-phone-number' class='label-mw-250' label='' readonly>
            <gz-input gz-form-input placeholder=''></gz-input>
          </gz-form-field>

          <div class="licensing-card-buttons-container">
            <div class="licensing-card-buttons">
              <gz-button class='licensing-card-button' id='show-change-partner-menu-button' type='outline' buttonHeight='small' buttonFontSize='small'></gz-button>
            </div>
          </div>
        </div>
      </div>

      <div class="licensing-header">
        <div class="licensing-header--top">
            <gz-title class="title" id="license-usage-details-title" fontweight="500" fontsize="20"></gz-title>
            <gz-info-box severity='warning' class="hidden" id='license-usage-details-info-box-message'></gz-info-box>

            <div id='logout-notice-container'>
              <span class='hidden ds-icon ds-icon-notification_warning warning mr-2' id='logout-warning-icon'></span>
                <span id='logout-info'>
                  <span class='hidden' id='logout-info-text'></span>
                  <gz-button class='hidden' type='outline' id='logout-button' buttonHeight='small' lowercase></gz-button>
              </span>
            </div>
        </div>
      </div>
      <div class="license-usage-details-content">
        <div class="licenses-grid">
            <gz-grid-view removeFilters hideFiltersToggle hideGridRefresh hideFooter disableGridSettings showGlobalActions>
               <div slot="grid-header-actions-slot">
                 <gz-button class='hidden' id='add-product-button'></gz-button>
                 <gz-button class='hidden' type='outline' id='delete-product-button' disabled></gz-button>
                 <gz-button class='hidden' type='outline' id='buy-product-button' disabled></gz-button>

                 <gz-tooltip id='refresh-button-tooltip' class='tooltip'>
                   <gz-button class='hidden' type='outline' id='refresh-product-button' disabled></gz-button>
                 </gz-tooltip>

               </div>

               <div slot="no-results--additional-data">
                  <gz-text id="license-usage-details-empty-state-text" fontSize="14"></gz-text>
               </div>
            </gz-grid-view>
        </div>
      </div>
    </div>
  </div>
`;
